module.exports = __webpack_public_path__ + "img/vip.b4564235.png";